import { useQuery } from "@tanstack/react-query";
import type { AdminListingChangeDetailDTO } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/listing-changes/:id — drawer payload (request + the live
// marketplace row it would overwrite; `live: null` when the linked row is
// gone). 404 propagates as an ApiClientError with `.status === 404`.
//
// Disabled when `id` is null so the hook mounts unconditionally on the queue
// page without firing a request until the URL carries `?request=` (the
// use-admin-submission convention).
export function useListingChange(id: string | null) {
  return useQuery<AdminListingChangeDetailDTO, ApiClientError>({
    enabled: !!id,
    queryKey: id
      ? queryKeys.admin.listingChanges.detail(id)
      : queryKeys.admin.listingChanges.detail("__pending__"),
    queryFn: async () => {
      if (!id) throw new Error("listing change id required");
      return apiFetch<AdminListingChangeDetailDTO>(
        `/admin/listing-changes/${encodeURIComponent(id)}`,
      );
    },
  });
}
